module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Safety Confirmation List')))])])]), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.goSafetyConfirmationNew()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('New Registration')))])])])]) : _vm._e(), _c('div', [(_vm.searchEnd && _vm.safetyConfirmations.length > 0) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("タイトル")]), _c('th', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("対象者人数")]), _c('th', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("確認済人数")]), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("ステータス")]), (_vm.isSystemManagement) ? _c('th', {
    staticClass: "col-sm-2"
  }) : _vm._e()])]), _c('tbody', _vm._l((_vm.safetyConfirmations), function(safetyConfirmation, index) {
    return _c('tr', [_c('td', [(safetyConfirmation.attributes['is-training']) ? _c('span', {
      staticClass: "badge",
      staticStyle: {
        "background-color": "#0000cc"
      }
    }, [_vm._v("訓練")]) : _vm._e()]), _c('td', [_c('a', {
      on: {
        "click": function($event) {
          _vm.goSafetyConfirmationAnswers(safetyConfirmation.id)
        }
      }
    }, [_vm._v(_vm._s(safetyConfirmation.attributes.title))])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(safetyConfirmation.attributes['target-count']))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(safetyConfirmation.attributes['confirmed-count']))]), _c('td', [_vm._v(_vm._s(safetyConfirmation.attributes.status))]), (_vm.isSystemManagement) ? _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('a', {
      staticClass: "btn btn-info btn-sm margin-right",
      on: {
        "click": function($event) {
          _vm.goSafetyConfirmationEdit(safetyConfirmation.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Edit')))]), (!safetyConfirmation.attributes['is-closed']) ? _c('a', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.safetyConfirmationClose(safetyConfirmation.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Close')))]) : _vm._e()]) : _vm._e()])
  }))])])]), (_vm.nextExist) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-default next-page-search-btn",
    on: {
      "click": function($event) {
        _vm.search(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Read More')))])])])]) : _vm._e()]) : _vm._e(), (_vm.searchEnd && _vm.safetyConfirmations.length == 0) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1384cc3b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SafetyConfirmationList.vue
// module id = 764
// module chunks = 1